import { format } from 'date-fns';
import getLocale from './getLocale';
import { defaultDateTimeFormat } from './constants';

const getDateTime = (dateFormat = defaultDateTimeFormat) => format(new Date(), dateFormat, { locale: getLocale() });

export default getDateTime;
